import { CommonModule, DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { indicadorAlertaPermanencia } from '../../../modal/indicadorAlertaPermanencia';
import { StatusIndicadorAlerta } from '../../../utilidades/enum/status.indicador.alerta.enum';
import { posto_simple } from '../../../modal/posto_simple';
import { mensagem } from '../../../modal/mensagem';
import { DateTimeFormatPipe } from '../../../utilidades/date-time-format.pipe';
import { TimeFormatPipe } from '../../../utilidades/time-format.pipe';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas';
import { FormControl, FormsModule } from '@angular/forms';
import * as ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { StatusCorIndicadorAlerta } from '../../../utilidades/enum/status.cor.indicardor.alerta.enum';
import $ from 'jquery'; // Import jQuery
import { MultipleSelectionSelectAllComponent } from '../../../utilidades/multiple-selection-select-all/multiple-selection-select-all.component';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { PostoService } from '../../../service/posto.service';
import { RegiaoService } from '../../../service/regiao.service';
import { LogosBase64 } from '../../../utilidades/logosBase64'
import { Console } from 'console';
import { RelatorioService } from '../../../service/relatorio.service';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import FileSaver from 'file-saver';
import { PostoVagas } from '../../../utilidades/interfaceRelatorioVagasDesproporcionais';

interface VagasDias {
  dia: string;
  totalDia: number;
  totalPeriodo: number;
  numeroDias: number;
  mediaDia: number;
  diferenca: number;
}

interface Servico {
  descricao: string;
  dias: VagasDias[];
}

interface Orgao {
  descricao: string;
  servicos: Servico[];
}

// Tipo para ordenação segura
type CampoOrdenavel = keyof Pick<
  VagasDias,
  'dia' | 'totalDia' | 'totalPeriodo' | 'numeroDias' | 'mediaDia' | 'diferenca'
>;


@Component({
  selector: 'app-vagas-desproporcionais',
  standalone: true,
  imports: [
    MatSidenavModule,
    MatCardModule,
    FormsModule,
    MatMenuModule,
    CommonModule,
    RouterLink,
    RouterOutlet,
    RouterModule,
    MultipleSelectionSelectAllComponent,
    MatFormFieldModule, MatDatepickerModule
  ],
  templateUrl: './vagas-desproporcionais.component.html',
  styleUrl: './vagas-desproporcionais.component.scss',
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    TimeFormatPipe, DateTimeFormatPipe, provideNativeDateAdapter()]
})


export class VagasDesproporcionaisComponent implements OnInit {
  public SemDados: boolean = false;
  larguraTela: number = window.innerWidth;
  login: string | null | undefined = null;
  data: PostoVagas[] = [];
  dataMensagem = [];
  listaPostos: any = [];
  listaRegiao: any = [];
  RegiaoSelecionada: any;
  PostosSelecionados: any[] = [];
  usuario: any;
  feitaPesquisa: boolean = true;

  campoOrdenado: string = '';
  ordem: 'asc' | 'desc' = 'asc';

  
  


  constructor(private route: ActivatedRoute, private router: Router,
    private relatorioService: RelatorioService, @Inject(DOCUMENT) private document: Document,
    private postoService: PostoService, private regiaoService: RegiaoService,
    public timeFormatPipe: TimeFormatPipe,
    public dateTimeFormatPipe: DateTimeFormatPipe) {
    try {
      const localStorage = document.defaultView?.localStorage;
      if (localStorage)
        this.login = localStorage.getItem('login');
      if (this.login == null || this.login == undefined)
        this.router.navigate(['/iniciar']);
    }
    catch (ex) {
      this.router.navigate(['/iniciar']);
    }
  }
  ngOnInit() {
    let login = localStorage.getItem('login');
    this.usuario = localStorage.getItem('salaSituacao');
    this.listarPostos();
    this.listarRegiao();
  }
  processarInfo(info: any) {
    this.PostosSelecionados = info;
  }

  getTotalAtendimentos(ponto: any): number {
    return ponto.pontosAtendimentos.reduce((sum: number, pa: any) => sum + pa.atendimentos.length, 0);
  }

  listarPostos() {
    let sala: any = localStorage.getItem('salaSituacao');
    sala = JSON.parse(sala);
    this.postoService.getPostoUsuario(this.usuario).pipe().subscribe((result: any) => {
      result.Posto.forEach((posto: any) => {
        this.listaPostos.push(posto);
      });

      this.listaPostos.sort(function (a: any, b: any) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      })
    })
  }
  listarRegiao() {
    this.regiaoService.getRegiaoUsuario(this.usuario).pipe().subscribe((element: any) => {
      console.log(element);
      element.Regiao.forEach((regiao: any) => {
        this.listaRegiao.push(regiao);
      });
      this.listaRegiao.sort(function (a: any, b: any) {
        if (a.descricao > b.descricao) {
          return 1;
        }
        if (a.descricao < b.descricao) {
          return -1;
        }
        return 0;
      })
    })
  }

  onSelecionar(valor: string) {
    this.RegiaoSelecionada = valor; // Atualiza o valor quando o select muda
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.larguraTela = window.innerWidth;
  }

  Pesquisa() {
    if (this.PostosSelecionados.length != 0) {
      this.feitaPesquisa = false;

      this.data = [];
      var retrievedObject = localStorage.getItem('salaSituacao');
      if (retrievedObject != null) {
        var sala = JSON.parse(retrievedObject);
        this.relatorioService.getRelatorioVagasDesproporcionais(sala['postos'], this.PostosSelecionados.toString(), 4).pipe(
        ).subscribe((response: PostoVagas[]) => {
          this.data = response;
          console.log(this.data);
          this.data.forEach(posto => {
            posto.orgaos.forEach(org => {
              org.servicos.forEach(ser => {
                ser.dias = ser.dias.sort((a, b) => {
                  if (a.dia < b.dia) return -1;
                  if (a.dia > b.dia) return 1;
                  return 0;
                });
              });
              posto.orgaos = posto.orgaos.sort((a, b) => {
                if (a.descricao < b.descricao) return -1;
                if (a.descricao > b.descricao) return 1;
                return 0;
              });
            });
          });
          this.data = this.data.sort((a, b) => {
            if (a.descricao < b.descricao) return -1;
            if (a.descricao > b.descricao) return 1;
            return 0;
          });
          console.log(this.data);
        });
      }
    }
    else {
      this.feitaPesquisa = true;
      this.data = [];
    }
  }

  hasNoServicosComDias(posto: any): boolean {
    return posto.orgaos.every((orgao: { servicos: any[]; }) =>
      orgao.servicos.every(servico =>
        !servico.dias || servico.dias.length === 0
      )
    );
  }

  isPrimeiroComDia(servicos: any[], index: number): boolean {
    const primeiroComDiaIndex = servicos.findIndex(s => s.dias && s.dias.length > 0);
    return primeiroComDiaIndex === index;
  }

  filtrarPesquisa() {
    this.Pesquisa();
  }

  generateTableBody() {
    const body: any[] = [];

    // Cabeçalho da Tabela
    body.push([
      { text: 'Posto', style: 'header' },
      { text: 'Fila', style: 'header' },
      { text: 'Data Início / Hora', style: 'header' },
      { text: 'Data Fim / Hora', style: 'header' },
      { text: 'Tempo', style: 'header' },
      { text: 'Cidadão na Espera', style: 'header' },
      { text: 'Pontos Abertos', style: 'header' }
    ]);

    // Linhas de Dados

    return body;
  };

  exportarParaExcel(): void {
    const data: any[] = [];
    this.data.forEach(posto => {
      posto.orgaos.forEach(org => {
        org.servicos.forEach(ser => {
          ser.dias.forEach((dia, pontoIndex) => {
            data.push({
              'Posto': posto.descricao,
              'Orgão': org.descricao,
              'Serviço': ser.descricao,
              'Dia': this.formatDate(dia.dia),
              'Total do dia': dia.totalDia,
              'Total do Período': dia.totalPeriodo,
              'Dias com registros': dia.numeroDias,
              'Média': dia.mediaDia,
              'Diferença': dia.diferenca,
            });
          });
        });
      });
    });

    const worksheet: XLSX.WorkSheet = {};
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;
    XLSX.utils.sheet_add_aoa(worksheet, [['Relatório de Vagas Desproporcionais - Emitido por: ' + this.login + " - " + formattedDateTime]], { origin: 'A1' });
    XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: 'A2' });
    XLSX.utils.sheet_add_json(worksheet, data, { origin: 'A3' });
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Relatório': worksheet },
      SheetNames: ['Relatório']
    };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const formattedDate2 = today.toISOString().split('T')[0];
    FileSaver.saveAs(dataBlob, 'relatorio_vagas_desproporcionais-' + formattedDate2 + '.xlsx');
  }

  exportToPDF() {
    const body: any[] = [];

    body.push([
      { text: 'Posto', style: 'tableHeader' },
      { text: 'Orgão', style: 'tableHeader' },
      { text: 'Serviço', style: 'tableHeader' },
      { text: 'Data', style: 'tableHeader' },
      { text: 'Total do dia', style: 'tableHeader' },
      { text: 'Total do Período', style: 'tableHeader' },
      { text: 'Dias com registros', style: 'tableHeader' },
      { text: 'Média', style: 'tableHeader' },
      { text: 'Diferença', style: 'tableHeader' },
    ]);

    for (const item of this.data) {

      for (const itemOrgao of item.orgaos) {
        for (const itemServico of itemOrgao.servicos) {
          const dias = itemServico.dias;
          for (let i = 0; i < itemServico.dias.length; i++) {
            const dia = dias[i];

            const row: any[] = [];

            if (i === 0) {
              row.push({
                text: item.descricao,
                rowSpan: dias.length
              });
            } else {
              row.push({});
            }

            if (i === 0) {
              row.push({
                text: itemOrgao.descricao,
                rowSpan: dias.length
              });
            } else {
              row.push({});
            }

            if (i === 0) {
              row.push({
                text: itemServico.descricao,
                rowSpan: dias.length
              });
            } else {
              row.push({});
            }

            row.push({ text: this.formatDate(dia.dia) });
            row.push({ text: dia.totalDia });
            row.push({ text: dia.totalPeriodo });
            row.push({ text: dia.numeroDias });
            row.push({ text: dia.mediaDia });
            row.push({ text: dia.diferenca });

            body.push(row);
          }
        }
      }
    }
    const today = new Date();
    const formattedDate = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;
    const formattedTime = `${today.getHours().toString().padStart(2, '0')}:${today.getMinutes().toString().padStart(2, '0')}`;
    const formattedDateTime = `${formattedDate} - ${formattedTime}`;
    const docDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            {
              image: LogosBase64.logo1,
              width: 100,
              alignment: 'left',
              margin: [0, 0, 10, 0]
            },
            {
              width: "*", // Ocupa o espaço do meio
              text: "" // Espaço vazio entre os logos
            },
            {
              width: "auto", // Ajusta ao conteúdo dos logos
              alignment: "right",
              columnGap: 35, // Espaço fixo entre os logos
              columns: [
                {
                  image: LogosBase64.logo2,
                  width: 60,

                },
                {
                  image: LogosBase64.logo3,
                  width: 60,

                },
                {
                  image: LogosBase64.logo4,
                  width: 60,

                }
              ]
            }
          ]
        },
        {
          text: `Relatório: Vagas Desproporcionais`,
          style: 'header'
        },
        {
          columns: [

            {
              width: "auto", // Garante que o login não fique comprimido
              text: `Emitido por: ${this.login}` + ` - ` + `Data ${formattedDateTime}`,
              style: 'posto',
              fontSize: 8,
              margin: [0, 30, 0, 10],// Adiciona um espaçamento superior
              noWrap: true // Impede a quebra do texto
            },
          ]
        },
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: body,
          },
          layout: 'lightHorizontalLines',
          style: 'tabelaBody'
        },
        {
          text: [
            { text: "Rua Agueda Gonçalves, 240 - Taboão da Serra - SP, 06760-900 - Tel:(11)28456000 (PABX)\n", fontSize: 8, alignment: 'center' },
            { text: "Correspondência: Caixa Postal 25901 - CEP: 05513-970 - SÃO PAULO-SP\n", fontSize: 8, alignment: 'center' },
            { text: "www.prodesp.sp.gov.br - prodesp@prodesp.sp.gov.br", fontSize: 8, alignment: 'center' }
          ],
          margin: [0, 10, 0, 0] // Remove espaçamento entre as linhas
        }
      ],
      styles: {
        header: {
          fontSize: 6,
          bold: true,
          alignment: 'center' as const // Alinhar texto centralizado
        },
        tableHeader: {
          bold: true,
          fontSize: 8,
          fillColor: '#eeeeee'
        },
        tabelaBody: {
          fontSize: 10
        }
      }
    };
    const formattedDate2 = today.toISOString().split('T')[0];
    pdfMake.createPdf(docDefinition).download('relatorio_vagas_desproporcionais-' + formattedDate2 + '.pdf');
  }

  formatDate(value: number | string): string {
    if (value == null || value == "") {
      return "";
    }
    const date = new Date(value);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit'
    });
  }

  getLetterFromNumber(num: number): string {
    const baseCharCode = 'A'.charCodeAt(0); // Código ASCII para 'A'
    return String.fromCharCode(baseCharCode + num - 1);
  }

  getTodayDate(): string {
    const date = new Date();
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  

  ordenarTabela(campo: CampoOrdenavel): void {
    if (this.campoOrdenado === campo) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc';
    } else {
      this.campoOrdenado = campo;
      this.ordem = 'asc';
    }

    this.data?.forEach(posto => {
      posto.orgaos?.forEach(orgao => {
        orgao.servicos?.forEach(servico => {
          servico.dias?.sort((a, b) => {
            let valA = a[campo];
            let valB = b[campo];

            if (campo === 'dia') {
              valA = new Date(valA as unknown as string).getTime();
              valB = new Date(valB as unknown as string).getTime();
            }

            return this.ordem === 'asc'
              ? valA > valB ? 1 : valA < valB ? -1 : 0
              : valA < valB ? 1 : valA > valB ? -1 : 0;
          });
        });
      });
    });
  }

  ordenarTabelaServico(): void {
    if (this.campoOrdenado === 'servico') {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc';
    } else {
      this.campoOrdenado = 'servico';
      this.ordem = 'asc';
    }
  
    this.data?.forEach(posto => {
      posto.orgaos?.forEach(orgao => {
        orgao.servicos = orgao.servicos.sort((a, b) => {
          const valA = a.descricao?.toLowerCase() ?? '';
          const valB = b.descricao?.toLowerCase() ?? '';
  
          return this.ordem === 'asc'
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        });
      });
    });
  }

  ordenarTabelaOrgao(): void {
    if (this.campoOrdenado === 'orgao') {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc';
    } else {
      this.campoOrdenado = 'orgao';
      this.ordem = 'asc';
    }
  
    // Ordena os órgãos de cada posto
    this.data?.forEach(posto => {
      posto.orgaos = posto.orgaos.sort((a, b) => {
        const valA = a.descricao?.toLowerCase() ?? '';
        const valB = b.descricao?.toLowerCase() ?? '';
  
        return this.ordem === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      });
    });
  }
  
  
  
  
  
  
}